import {  useState } from 'react';
import { Outlet } from 'react-router';
import Navbar from './Navbar';
import Footer from './Footer';
import AlertDialog from './AlertDialog';
import SackbarElement from './SackbarElement';
import WorldCup2026 from '../../components/landing/WorldCup2026';

const Layout = () => {
  
  const [showWorldCup, setShowWorldCup] = useState(true);

  return (
    <div>
      <Navbar />
      <main>
        {showWorldCup && <WorldCup2026 
          onDateReached={() => {
            setShowWorldCup(false);
          }}
          close={() => {
            setShowWorldCup(false);
          }}
        />}
        <Outlet />
      </main>
      <Footer />
      <AlertDialog />
      <SackbarElement />
    </div>
  );
};

export default Layout;
